import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import { SopModuleType } from "./sopTypes";
import { sopModuleReducer } from "./reducer";
import {
  createSopModuleListAction,
  deleteSingleSopDetailsAction,
  getSingleSopDetailsAction,
  getSopModuleListAction,
  getUniqueCheckSopFileNameAction,
  hideUnhideSopAction,
  updateSopModuleAction,
} from "./action";

export const sopModuleSlice = createSlice({
  name: "sopModule",
  initialState,
  reducers: sopModuleReducer,
  extraReducers: {
    [createSopModuleListAction.pending.toString()]: (state: SopModuleType) => ({
      ...state,
      fetching: true,
    }),
    [createSopModuleListAction.fulfilled.toString()]: (
      state: SopModuleType,
      { payload }
    ) => {
      const { success, status_code, message, result } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success: success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success: success,
        message: message,
      };
    },

    [createSopModuleListAction.rejected.toString()]: (
      state: SopModuleType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [updateSopModuleAction.pending.toString()]: (state: SopModuleType) => ({
      ...state,
      fetching: true,
    }),
    [updateSopModuleAction.fulfilled.toString()]: (
      state: SopModuleType,
      { payload }
    ) => {
      const { success, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success: success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success: success,
        message: message,
      };
    },

    [updateSopModuleAction.rejected.toString()]: (
      state: SopModuleType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [getSopModuleListAction.pending.toString()]: (state: SopModuleType) => ({
      ...state,
      fetching: true,
    }),
    [getSopModuleListAction.fulfilled.toString()]: (
      state: SopModuleType,
      { payload }
    ) => {
      const { status_code, result, message, success } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        sopModuleList: result?.data,
        sopModuleTotalCount: result?.total_count,
        message,
      };
    },
    [getSopModuleListAction.rejected.toString()]: (
      state: SopModuleType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
    [getSingleSopDetailsAction.pending.toString()]: (state: SopModuleType) => ({
      ...state,
      fetching: true,
    }),
    [getSingleSopDetailsAction.fulfilled.toString()]: (
      state: SopModuleType,
      { payload }
    ) => {
      const { status_code, result, message, success, total_count } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        sopModuleList: result,
        statusCode: status_code,
        singleSopDetails: result,
        message,
      };
    },
    [getSingleSopDetailsAction.rejected.toString()]: (
      state: SopModuleType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
    [getUniqueCheckSopFileNameAction.pending.toString()]: (
      state: SopModuleType
    ) => ({
      ...state,
      uniqueCheckFileNameFetching: true,
    }),
    [getUniqueCheckSopFileNameAction.fulfilled.toString()]: (
      state: SopModuleType,
      { payload }
    ) => {
      const { status_code, result, message, success, total_count } = payload;
      if (success === 0) {
        return {
          ...state,
          uniqueCheckFileNameFetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        uniqueCheckFileNameFetching: false,
        statusCode: status_code,
        uniqueCheckFileNameMessage: message,
      };
    },
    [getUniqueCheckSopFileNameAction.rejected.toString()]: (
      state: SopModuleType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      uniqueCheckFileNameFetching: false,
    }),
    [deleteSingleSopDetailsAction.pending.toString()]: (
      state: SopModuleType
    ) => ({
      ...state,
      fetching: true,
    }),
    [deleteSingleSopDetailsAction.fulfilled.toString()]: (
      state: SopModuleType,
      { payload }
    ) => {
      const { status_code, result, message, success, total_count } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        message: message,
        success: success,
      };
    },
    [deleteSingleSopDetailsAction.rejected.toString()]: (
      state: SopModuleType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [hideUnhideSopAction.pending.toString()]: (state: SopModuleType) => ({
      ...state,
      fetching: true,
    }),
    [hideUnhideSopAction.fulfilled.toString()]: (
      state: SopModuleType,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          success,
          fetching: false,
          statusCode: status_code,
          error: message,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,    
        message: message,

      };
    },
    [hideUnhideSopAction.rejected.toString()]: (
      state: SopModuleType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
  },
});
export const {
  resetSopModuleError,
  resetSopModuleSuccess,
  resetSopModuleFetching,
  resetSopModuleMessage,
  resetSopModuleListing,
  resetSopModuleListTotal,
  resetSopModuleStatusCode,
  resetSingleSopDetails,
  resetUniqueCheckFileNameMessage,
} = sopModuleSlice.actions;
